import { Text, View } from 'react-native';
import { useJourney } from '../contexts/JourneyContext.js';
import SmallButton from '../elements/SmallButton.jsx';
import styles from '../Styles.jsx';

export default function PanelSupport({ dismiss }) {
  
  const journey = useJourney();

  const handleRestartSearch = () => {
    journey.restartSearch();
    dismiss();
  };

  const handleFinishSearch = () => {
    // TODO: Implement finish search logic
    //if (finishSearch) finishSearch();
  };

  const handleResetVoyage = () => {
    // TODO: Implement reset voyage logic
    //if (resetVoyage) resetVoyage();
  };

  const handleResetAll = () => {
    journey.reset();
    dismiss();
  };

  const handleReloadData = () => {
    // TODO: Implement reload data logic
    //if (reloadData) reloadData();
  };

  const toggleDebugGPS = () => {
    journey.setIsDebuggingGPS(!journey.isDebuggingGPS);
  };



  return (
    <View style={styles.panelFrame}>
      <Text style={{textAlign: 'center'}}>Support Panel</Text>
      <Text>{journey.voyagerCode}</Text>
      
      <SmallButton
        onPress={toggleDebugGPS}
        title={`Debug GPS: ${journey.isDebuggingGPS ? 'ON' : 'OFF'}`}
      />
      
      <SmallButton
        onPress={handleRestartSearch}
        title="Restart Current Search"
      />
      
      <SmallButton
        onPress={handleFinishSearch}
        title="Finish Current Location"
      />
      
      <SmallButton
        onPress={handleResetVoyage}
        title="Reset Voyage"
      />
      
      <SmallButton
        onPress={handleReloadData}
        title="Reload Data"
      />
      
      <SmallButton
        onPress={handleResetAll}
        title="Reset Everything"
      />
      
      <SmallButton
        onPress={dismiss}
        buttonStyle={styles.smallCloseButton}
        title="Done"
      />
    </View>
  );
}
